import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/Home.scss';
import { tryFetch } from '../../../Helpers/FetchAPI';

type Product = {
  id: string;
  product_name: string;
  product_slug: string;
  merchant_slug: string;
  unit_price: string;
  is_sale: boolean;
  sale_price: string;
  legal_age: boolean;
  media: { media_url: string }[];
};

type Merchant = {
  id: string;
};

const GottPlusSection: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  const currency = process.env.REACT_APP_CURRENCY;

  useEffect(() => {
    const fetchProducts = async () => {
      try {

        const merchantsRes = await tryFetch({
          url: `/merchants`,
          method: 'GET'
        });

        if (!merchantsRes.is_success) return;

        const merchants: Merchant[] = Array.isArray(merchantsRes.data)
          ? merchantsRes.data as Merchant[]
          : [];

        let allProducts: Product[] = [];

        for (const merchant of merchants) {

          const productRes = await tryFetch({
            url: `/merchants/${merchant.id}/products`,
            method: 'GET',
            query: `?limit=999`
          });

          if (productRes.is_success && Array.isArray(productRes.data)) {

            const legalProducts = productRes.data.filter(
              (p: Product) => p.legal_age === true
            );

            allProducts = [...allProducts, ...legalProducts];
          }
        }

        // shuffle
        const shuffled = allProducts.sort(() => 0.5 - Math.random());

        setProducts(shuffled.slice(0, 10));

      } catch (error) {
        console.error('Error fetching Gott+ products:', error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleImageLoad = (id: string) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  const truncateText = (text: string, maxLength: number): string =>
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  return (
    <div className="favorites">
      <h3>Gott+</h3>

      <div className="favorites-list">
        {products.map((product) => (

          <div key={product.id} className="favorite-item">

            <Link to={`/merchant/${product.merchant_slug}/product/${product.product_slug}`}>

              {product.media?.length > 0 ? (
                <img
                  src={product.media[0]?.media_url}
                  alt={product.product_name}
                  className={`favorite-image ${
                    loadedImages[`gottplus-${product.id}`] ? 'loaded' : ''
                  }`}
                  onLoad={() => handleImageLoad(`gottplus-${product.id}`)}
                />
              ) : (
                <div className="favorite-image no-image"></div>
              )}

              <p className="favorite-name">
                {truncateText(product.product_name, isMobile ? 16 : 30)}
              </p>

              <div className="favorite-price">
                {product.is_sale ? (
                  <>
                    <span className="sale-price">
                      {currency} {parseFloat(product.sale_price).toFixed(2)}
                    </span>
                    <span className="old-price">
                      {currency} {parseFloat(product.unit_price).toFixed(2)}
                    </span>
                  </>
                ) : (
                  <span className="regular-price">
                    {currency} {parseFloat(product.unit_price).toFixed(2)}
                  </span>
                )}
              </div>

            </Link>

          </div>

        ))}
      </div>
    </div>
  );
};

export default GottPlusSection;